import { io } from 'socket.io-client';

const TOKEN_KEY = 'nh_auth_token';

/**
 * QueueSocketClient
 * Socket.IO client for the /queue namespace (real-time queue updates).
 * Follows the same pattern as scribeSocketClient.js.
 */
class QueueSocketClient {
  constructor() {
    this.socket = null;
    this.handlers = {};
    this.isConnected = false;
    this.practiceId = null;
  }

  connect(practiceId) {
    if (this.socket) {
      this.disconnect();
    }

    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      console.warn('[QueueSocket] No auth token — skipping connect');
      return this;
    }

    this.practiceId = practiceId;

    const serverUrl = window.location.origin.replace(':3000', ':3001');
    this.socket = io(`${serverUrl}/queue`, {
      auth: { token },
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 15000
    });

    const events = [
      'queueItemClaimed',
      'queueItemResolved',
      'queueItemReleased',
      'queueItemCreated',
      'queueSummaryUpdate'
    ];

    for (const event of events) {
      this.socket.on(event, (data) => {
        if (this.handlers[event]) this.handlers[event](data);
      });
    }

    this.socket.on('connect', () => {
      this.isConnected = true;
      // Join practice queue room on connect/reconnect
      if (this.practiceId) {
        this.socket.emit('joinPracticeQueue', { practiceId: this.practiceId });
      }
      if (this.handlers.connect) this.handlers.connect();
    });

    this.socket.on('disconnect', (reason) => {
      this.isConnected = false;
      if (this.handlers.disconnect) this.handlers.disconnect(reason);
    });

    this.socket.on('connect_error', (error) => {
      console.error('[QueueSocket] Connection error:', error.message);
      if (this.handlers.error) this.handlers.error(error.message);
    });

    return this;
  }

  on(event, handler) {
    this.handlers[event] = handler;
    return this;
  }

  off(event) {
    delete this.handlers[event];
    return this;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    this.isConnected = false;
    this.handlers = {};
    this.practiceId = null;
  }
}

// Singleton instance
const queueSocketClient = new QueueSocketClient();
export default queueSocketClient;
